var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgHaidiEditIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 12,
  height: 12,
  fill: "none"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "currentColor"
}, /*#__PURE__*/React.createElement("path", {
  d: "M11.586.419 11.58.413a1.41 1.41 0 0 0-1.993 0L5.041 4.958a.257.257 0 0 0-.06.1l-.824 2.47a.25.25 0 0 0 .316.316l2.47-.823a.257.257 0 0 0 .1-.061l4.545-4.545a1.408 1.408 0 0 0 0-1.993l-.002-.003Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M10 8a1 1 0 0 0-1 1v1H2V3h.999a1 1 0 0 0 0-2h-1a2 2 0 0 0-2 2v7a2 2 0 0 0 2 2h7a2 2 0 0 0 2-2V9a1 1 0 0 0-1-1Z"
}))));
export default SvgHaidiEditIcon;